import { createContext } from 'react';

// REQ-AUTH-001: Separate context and types from provider component

export interface User {
  id: string;
  email: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  userId: string | null;
  jwt: string | null;
  user: User | null;
}

export interface AuthContextValue {
  auth: AuthState;
  verifyToken: (token: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

AuthContext.displayName = 'AuthContext';
